import { useEffect } from "react";
import Spinner from "@/components/ui/Spinner.jsx";
import ConfigService from "@/components/service/ConfigService.js";

/**
 * Redirect stub for "/" (and, via the catch-all route, any unknown URL):
 * immediately bounces to the client app. Renders only a spinner for the
 * instant before the browser navigates — there's no real page here.
 */
function Home() {
  const configService = ConfigService.getInstance();

  // clientUrl is per-environment: wait for config before redirecting, or a
  // prod visitor would be sent to the bundled (local) default.
  useEffect(() => {
    let cancelled = false;
    configService.load().then(() => {
      if (!cancelled) window.location.href = configService.get().clientUrl;
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex flex-1 items-center justify-center py-12">
      <Spinner size="lg" />
    </div>
  );
}

export default Home;
